module.exports = __webpack_public_path__ + "static/feature-event-450bf87da81b9a6bacf73afaeb22d685.png";